import axios from 'axios';
import _ from 'lodash';
import { batchQuery, getCommentsQuery, getUsersQuery } from './queries';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import { renameKey } from '../../utils';
import Split from '../split';

const getComments = (type, itemId) =>
    new Promise((resolve, reject) => {
        const useExpressMigration = Split.getBooleanTreatment('use_express_migration_endpoints');
        const migrationQueryBuilder = useExpressMigration ? buildExpressQuery : buildLoopbackQuery;
        const useExpressAuth = Split.getBooleanTreatment('use_express_auth_endpoints');
        const authQueryBuilder = useExpressAuth ? buildExpressQuery : buildLoopbackQuery;
        const commentsQuery = getCommentsQuery({
            type,
            itemId,
            filterDeleted: true,
            queryBuilder: migrationQueryBuilder,
        });
        const commentsRequest = axios.get(commentsQuery);

        commentsRequest
            .then((commentsResponse) => {
                const comments = commentsResponse.data;
                if (useExpressMigration) {
                    renameKey(comments, '_id', 'id');
                }
                const userIds = _.uniq(_.map(comments, 'created_by'));

                const userQuery = batchQuery(getUsersQuery, { fields: ['id', 'name'], ids: userIds, queryBuilder: authQueryBuilder }, 'ids');
                const userRequest = _.map(userQuery, (q) => axios.get(q));

                return axios.all(userRequest).then(
                    axios.spread((...responses) => {
                        const users = _.reduce(responses, (acc, val) => [...acc, ...val.data], []);
                        if (useExpressAuth) {
                            renameKey(users, '_id', 'id');
                        }

                        const data = comments
                            .map((value) => {
                                const user = _.find(users, { id: value.created_by }) ? _.find(users, { id: value.created_by }).name : undefined;
                                return { ...value, user };
                            })
                            .filter((value) => value.user);

                        resolve({ comments: data });
                    })
                );
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getComments;
